import { createTheme } from "@mui/material/styles";

export const mytheme = createTheme({
  palette: {
    primary: {
      light: "#1b5e20",
      main: "#3f50b5",
      dark: "#002884",
      contrastText: "#fff",
      text: "#014601",
    },
  },
});
